import styled from "styled-components";
import { breakpoints, color, fontSize, fontFamily } from "style/constants";

export const Title = styled.h1`
  margin: 0;
  color: ${color.DARKBLUE};
  font-size: 65px;
  font-weight: 300;
  line-height: 100px;
`;

export const Subtitle = styled.h2`
  margin: 0;
  color: ${color.BLACK};
  font-family: ${fontFamily.secondary};
  font-size: ${fontSize.large};
  text-align: center;
  @media (max-width: ${breakpoints.lg}px) {
    max-width: 310px;
  }
  max-width: 570px;
`;

export const Paragraph = styled.p`
  @media (max-width: ${breakpoints.lg}px) {
    max-width: 310px;
  }
  text-align: center;
  max-width: 570px;
  margin: 0;
  margin-bottom: 10px;
  color: ${color.DARKERGRAY};
  font-size: ${fontSize.normal};
`;
